<template>
  <tbody class="is-size-5 has-text-text">
    <tr class="is-size-6  has-bg-light">
      <td>
        <span>{{search.research_date}}</span>
      </td>
      <td>
        <span v-if="search.lot_types && search.lot_types.length" v-for="(type, i) in search.lot_types" :key="i">
          {{lotTypeLabel(type)}}<span v-if="i < search.lot_types.length - 1">, </span>
        </span>
      </td>
      <td>
        <span>{{ addressArray(search.states) }}</span>
      </td>
      <td>
        <span>{{search.research_type | contactResearchLabel | truncateShort}}</span>
      </td>
      <td class="is-narrow">
        <span v-if="search.budget_max">{{search.budget_max | searchBudgetMaxLabel}}</span>
      </td>
      <td class="actions has-text-right is-paddingless" style="height: 50px">
        <div class="dropdown is-hoverable is-right is-paddingless is-height-full">
          <div class="dropdown-trigger is-border-left is-height-full" style="width:50px">
            <button class="button is-min-width-0 is-borderless is-radiusless is-height-full is-fullwidth" aria-haspopup="true" aria-controls="dropdown-menu">
              <span class="is-icon"><i class="fas fa-ellipsis-v"></i></span>
            </button>
          </div>
          <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content has-text-left">
              <a @click.prevent.stop="openStock(search)" class="dropdown-item">
                <span class="icon"><i class="fal fa-eye"></i></span> Afficher résultat dans le stock
              </a>
              <a @click.prevent.stop="openSearchModal(search)" class="dropdown-item">
                <span class="icon"><i class="fal fa-edit"></i></span> Modifier critères de recherche
              </a>
              <a @click.prevent.stop="deleteResearch(search.pk)" class="dropdown-item">
                <span class="icon"><i class="fal fa-trash"></i></span> Annuler recherche
              </a>
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr :key="search.name" class="is-border-bottom">
      <td colspan="6" class="is-clipped is-paddingless row-width-actions-bar">
        <div class="columns is-gapless">
          <div class="column is-padding-small is-self-centered">
            <a v-if="!isOpen" @click.prevent.stop="openSuggestion(search)">
              <span class="title is-6">Lots correspondants aux critères de recherche</span>
            </a>
            <a v-else @click="isOpen = false">
              <span class="title is-6">Lots correspondants aux critères de recherche</span>
            </a>
          </div>
          <div class="column is-narrow is-border-left">
            <a v-if="!isOpen" @click.prevent.stop="openSuggestion(search)"
              class="page-header-btn is-small is-square">
              <span class="icon is-small"><i class="fas fa-chevron-down"></i></span>
            </a>
            <a v-else @click="isOpen = false"
              class="page-header-btn is-small is-square">
              <span class="icon is-small"><i class="fas fa-times"></i></span>
            </a>
          </div>
        </div>
      </td>
    </tr>
    <tr v-if='isOpen' class="is-border-bottom">
        <td colspan="6" class="is-clipped is-paddingless" v-if="!loading && totalLot !== 0">
          <table class="table is-fullwidth is-marginless-bottom is-striped-v has-actionsontd">
            <thead>
              <tr class="is-size-6">
                <th class="is-border-bottom"><span>Status</span></th>
                <th class="is-border-bottom"><span>Lot</span></th>
                <th class="is-border-bottom"><span>Programme</span></th>
                <th class="is-border-bottom"><span>Nature</span></th>
                <th class="is-border-bottom"><span>Type</span></th>
                <th class="is-border-bottom"><span>Surface</span></th>
                <th class="is-border-bottom"><span>Code Postal</span></th>
                <th class="is-border-bottom"><span>Dispositif</span></th>
                <th class="is-border-bottom"><span>Prix</span></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="lot in lotsList" :key="lot.pk" class="is-size-6">
                <td class="is-narrow is-paddingless has-text-centered">
                  <span class="dot tooltip is-tooltip-right" :data-tooltip="lot.status|statusLabel" :class="statusColors(lot.status)"></span>
                </td>
                <td class="is-paddingless">
                  <router-link class="is-padding-right-small is-padding-left-xsmall is-height-full columns is-vcentered is-cell-hoverable" :to="{name: 'LotVue', params: {id: lot.pk}}">
                    <b>{{lot.ref || '-' | truncateShort}}</b>
                  </router-link>
                </td>
                <router-link class="is-cell-hoverable" :to="{name: 'ProgramVue', params: {id: lot.program}}" tag="td">
                  <a :title="lot.program_name">
                    <span class="is-size-6 has-text-grey">
                      {{lot.program_name | truncate(30)}}
                    </span>
                  </a>
                </router-link>
                <td>
                  <span v-if='lot.nature'>{{natureLabel(lot.nature)}}</span>
                  <span v-else>-</span>
                </td>
                <td>
                  <span v-if="lot.lot_type">{{lotTypeLabel(lot.lot_type)}}</span>
                  <span v-else>-</span>
                </td>
                <td>
                  <span v-if="lot.surface">{{lot.surface|prettyPrice}} m²</span>
                  <span v-else>-</span>
                </td>
                <td>
                  <span v-if="lot.address && lot.address.zip_code">
                    {{lot.address.zip_code || ''}}
                  </span>
                  <span v-else>-</span>
                </td>
                <td>
                  <span v-if="lot.tax_dispositifs && lot.tax_dispositifs.length > 0" :title="lot.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData)">
                    {{lot.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData) | truncate}}
                  </span>
                  <span v-else>-</span>
                </td>
                <td>
                  <span v-if="lot.sale_price">{{lot.sale_price | prettyPrice}} {{$currency}}</span>
                  <span v-else>-</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="!loading" class="columns is-gapless is-padding-left is-border-top is-padding-right is-vcentered">
            <div class="column">
              <pagination :loading="loading" @ChangePage="changePage($event)" :currentPage="lotCurrentPage"
                          :totalPage="lotTotalPage"></pagination>
            </div>
          </div>
        </td>
        <td colspan="6" class="is-clipped" v-else-if="!loading && totalLot === 0">
          <em><b>Aucun lot correspondant à la recherche</b></em>
        </td>
        <td v-else colspan="6" class="is-clipped" style="height: 100px; width: 100%;">
          <spinner-round :isLoading="loading" class="column is-relative" style="top: -10px; transform: translateY(-50%);"></spinner-round>
        </td>
    </tr>
  </tbody>
</template>

<script>
  import StockLots from '../../stock/StockLots'
  import { DefaultValues } from '@/mixins'

  export default {
    name: 'ContactSearchRow',
    components: {
      StockLots
    },
    mixins: [DefaultValues],
    props: {
      source: Object,
      index: Number
    },
    data () {
      return {
        isOpen: false,
        lotsList: [],
        loading: false,
        loadingLots: false,
        lotTotalPage: 0,
        sortBy: {},
        lotCurrentPage: 1,
        totalLot: 0
      }
    },
    filters: {
      prettyTaxDispositifs (values, data) {
        return values.map((x, i) => {
          if (i < 2) {
            return data[x].short_label || data[x].label
          }
        }).join(', ')
      }
    },
    computed: {
      search () {
        return this.source
      }
    },
    methods: {
      changePage (v) {
        this.lotCurrentPage = v
        this.$nextTick(() => {
          this.getLots(this.search)
        })
      },
      statusColors (val) {
        const COLORS = {
          available: 'has-bg-disponible',
          optioned: 'has-bg-optionne',
          sold: 'has-bg-acte',
          draft: 'has-bg-draft',
          archived: 'has-bg-draft',
          reserved: 'has-bg-reserve'
        }
        return COLORS[val]
      },
      deleteResearch (id) {
        this.$emit('deleteResearch', id)
      },
      openSearchModal (search) {
        this.$emit('openSearchModal', search)
      },
      openStock (s) {
        let query = {
          address__state_code: s.states && s.states.length ? s.states.map(x => x.state_code) : null,
          lots__lot_type: s.lot_types,
          lot_type: s.lot_types,
          sale_price__lte: s.budget_max
        }
        this.$router.push({name: 'StockPrograms', query})
      },
      openSuggestion (e) {
        this.getLots(e)
        this.$nextTick(() => {
        })
        this.isOpen = true
      },
      getLots (search, query) {
        this.loading = true
        let params = {
          lots__lot_type: search.lot_types,
          lot_type: search.lot_types,
          address__state_code: search.states && search.states.length ? search.states.map(x => x.state_code) : null,
          sale_price__lte: search.budget_max,
          status: ['available', 'optioned'],
          per_page: 15,
          page: this.lotCurrentPage,
          ...query
        }
        this.$api.lotService.get(params).then(r => {
          this.loading = false
          this.lotsList = r.data.items
          this.loadingLots = false
          this.lots = r.data.items
          this.lotTotalPage = r.data.pages
          this.lotCurrentPage = r.data.page
          this.totalLot = r.data.total
        }).catch(() => {
          this.loading = false
        })
      },
      addressArray (value) {
        let address = []
        if (value && value.length) {
          if (this.$configs.COUNTRY === 'FRA') {
            value.forEach(x => address.push(`${x.state} (${x.state_code}) `))
          } else {
            value.forEach(x => address.push(x.state))
          }
          return address.join(' /\n')
        }
      }
    },
    created () {
      this.$nextTick(() => {
        if (this.index === 0) this.openSuggestion(this.source)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactRightPanel/ContactSearchRow.vue